import { Entity, IEntity } from "./Entity";
import { IGoDefElement } from "./GoDefElement";
import { IOrgLevel1 } from "./OrgLevel1";

export interface IGoDefElementOrgLevel1 extends IEntity {
    GoDefElementID?: number;
    OrgLevel1ID?: number;
    GoDefElement?: IGoDefElement;
    OrgLevel1?: IOrgLevel1;
}

export class GoDefElementOrgLevel1 extends Entity implements IGoDefElementOrgLevel1 {
    public GoDefElementID = null;
    public OrgLevel1ID = null;
}